import type { UserProfile } from "@/mocks/configuracoes";

interface PermissionsMatrixProps {
  profiles: UserProfile[];
}

const modules = [
  "Dashboard", "Projetos", "CTA Arbóreo", "FCA", "Mapa",
  "Vistorias", "Fotos e Evidências", "Ambiental", "Carbono",
  "Documentos", "Partes", "RRR", "Relatórios", "Configurações",
];

const defaultPermissions: Record<string, string[]> = {
  "Administrador": modules,
  "Gestor ambiental": ["Dashboard", "Projetos", "CTA Arbóreo", "FCA", "Mapa", "Vistorias", "Fotos e Evidências", "Ambiental", "Carbono", "Documentos", "Partes", "RRR", "Relatórios"],
  "Responsável técnico": ["Dashboard", "Projetos", "CTA Arbóreo", "FCA", "Mapa", "Vistorias", "Fotos e Evidências", "Ambiental", "Carbono", "Documentos", "Partes", "RRR", "Relatórios"],
  "Técnico de campo": ["Dashboard", "Projetos", "CTA Arbóreo", "FCA", "Mapa", "Vistorias", "Fotos e Evidências"],
  "Analista GIS": ["Dashboard", "Projetos", "Mapa", "CTA Arbóreo", "Ambiental", "Relatórios"],
  "Fiscal ambiental": ["Dashboard", "Projetos", "CTA Arbóreo", "FCA", "Mapa", "Vistorias", "Ambiental", "Carbono", "Documentos", "Partes", "RRR", "Relatórios"],
  "Consultor externo": ["Dashboard", "Projetos", "CTA Arbóreo", "FCA", "Relatórios"],
  "Visualizador": ["Dashboard", "Projetos", "CTA Arbóreo", "Mapa", "Relatórios"],
  "Consulta pública": ["Dashboard", "Mapa", "Relatórios"],
};

export default function PermissionsMatrix({ profiles }: PermissionsMatrixProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-background-200">
            <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500 sticky left-0 bg-white z-10 min-w-[160px]">Perfil / Módulo</th>
            {modules.map((m) => (
              <th key={m} className="text-center py-3 px-2 text-xs font-medium text-foreground-500 min-w-[70px] whitespace-nowrap">{m}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {profiles.map((p) => {
            const perms = defaultPermissions[p.name] || [];
            return (
              <tr key={p.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="py-2.5 px-3 text-foreground-900 font-medium sticky left-0 bg-white z-10">
                  <div>{p.name}</div>
                  <div className="text-foreground-400 font-normal text-[10px]">{p.description}</div>
                </td>
                {modules.map((m) => (
                  <td key={m} className="text-center py-2.5 px-2">
                    {perms.includes(m)
                      ? <i className="ri-check-line text-primary-600 text-base" />
                      : <i className="ri-close-line text-foreground-200 text-base" />
                    }
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}